export default __webpack_public_path__ + "666902bb3fb8e33b35542e12740b7f57.png";